/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-06-05 10:57:29
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-22 16:18:15
 */

import { API_PREFIX } from './constant'
import { Request } from './request'

// 列表
export interface RDCEffortsListParams {
  startTime?: any
  endTime?: any
  current?: any
  size?: any
}

export function getRDCEffortsList(params: RDCEffortsListParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/expireddrugs/expiredDrugsList`,
    method: 'GET',
    params,
  }
}

// 导出
export function getRDCEffortsExport(params: RDCEffortsListParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/expireddrugs/expiredDrugsList/exportexcel`,
    method: 'GET',
    responseType: 'blob',
    params,
  }
}
